module.exports = __webpack_public_path__ + "static/media/song_detail.90070f79.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/mood/src/song_detail.gif
// module id = 114
// module chunks = 0